import $axios from '@/store/axios-instance.js';
import anchorme from "anchorme"; // or this
// import permissionShift from './permissionShift'

function _anchorme(text, type) {
    if (type === 'Chat') {
        return anchorme({
            input: text,
            options: {
                attributes: {
                    target: "_blank"
                }
            }
        })
    } else {
        return text
    }
}

export default {
    state: {
        chatList: null,
        currentChat: null,
        chatDictionaryList: null,
        foundMessageList: null,
        forward: {
            mode: false,
            messageList: []
        },
        chatCreateService: {
            mode: false,
            messageList: []
        }
    },
    mutations: {
        retrieveChatList(state, chatList) {
            if (!state.chatList) {
                state.chatList = chatList
            } else {
                state.chatList.activities = state.chatList.activities.concat(chatList.activities)
            }
        },
        retrieveChatDictionaryList(state, chatDictionaryList) {
            state.chatDictionaryList = chatDictionaryList
        },
        retrieveChat(state, chat) {
            state.currentChat = chat

            if (chat) {
                state.currentChat.comments.forEach(function (item) {
                    item.body = _anchorme(item.body, item.chatMessage.chatMessageTypeName)
                })

                if (state.chatList) {
                    let chatFind = state.chatList.activities.find(function (chatItem) {
                        return chatItem.id === chat.id
                    })
                    if (chatFind) {
                        chatFind.unreadCommentsCount = 0
                    }
                }
            }
        },
        retrieveChatNewComment(state, payload) {
            payload.comment.body = _anchorme(payload.comment.body, payload.comment.chatMessage.chatMessageTypeName)

            state.currentChat.comments.push(payload.comment)
            let attendee = state.currentChat.attendees.find(function (item) {
                return item.username === payload.currentUser
            })
            if (attendee) {
                let now = this._vm.moment().utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z'// 2020-09-25T04:07:08Z
                attendee.lastVisited = now
                state.currentChat.lastCommentDate = now
            }
        },

        removeChatComment(state, payload) {
            let index = state.currentChat.comments.findIndex(c => c.id === payload.comment)
            if(index > -1){
                state.currentChat.comments.splice(index, 1)
            }
        },

        retrieveChatCommentHistory(state, commentList) {
            commentList.slice().reverse()
                .forEach(function (item) {
                    item.body = _anchorme(item.body, item.chatMessage.chatMessageTypeName)
                    state.currentChat.comments.unshift(item)
                });
        },
        retrieveChatCommentList(state, payload) {
            if (payload.isClean) {
                state.currentChat.comments = []
            }
            payload.messageList.slice().reverse().forEach(function (item) {
                item.body = _anchorme(item.body, item.chatMessage.chatMessageTypeName)
                state.currentChat.comments.push(item)
            });
        },
        cleanChatList(state) {
            state.chatList = null
            state.currentChat = null
        },
        setChatForwardMode(state, payload) {
            state.forward.mode = payload
        },
        addChatForwardMessage(state, payload) {
            state.forward.messageList.push(payload)
        },
        removeChatForwardMessage(state, payload) {
            let index = state.forward.messageList.findIndex(c => c === payload)
            if(index > -1){
                state.forward.messageList.splice(index, 1)
            }
        },
        clearChatForward(state){
            state.forward.mode = false
            state.forward.messageList = []
        },
        searchChatMessage(state, payload) {
            state.foundMessageList = payload
        },
        clearSearchChatMessage(state) {
            state.foundMessageList = null
        },
        retrieveChatAttendees(state, payload) {
            if (state.currentChat) {
                state.currentChat.attendees = payload
            }
        },

        setChatCreateServiceMode(state, payload) {
            state.chatCreateService.mode = payload
        },
        addChatCreateServiceMessage(state, payload) {
            state.chatCreateService.messageList.push(payload)
        },
        removeChatCreateServiceMessage(state, payload) {
            let index = state.chatCreateService.messageList.findIndex(c => c === payload)
            if(index > -1){
                state.chatCreateService.messageList.splice(index, 1)
            }
        },
        clearChatCreateService(state){
            state.chatCreateService.mode = false
            state.chatCreateService.messageList = []
        },
    },
    actions: {
        retrieveAllChatList(context/*, payload*/) {
            return new Promise((resolve) => {
                // let newPayload = payload
                // let isInit = false
                let limit = 2000
                context.dispatch('checkHub').then(() => {
                    context.dispatch('retrieveChatList', {offset: 0, limit: 2000}).then(() => {
                        let chatPromiseList = []
                        let _chatCount = 2000
                        while(_chatCount < context.state.chatList.activityCount){
                            chatPromiseList.push(context.dispatch('retrieveChatList', {offset: _chatCount, limit: limit}))
                            _chatCount += limit
                        }

                        Promise.all(chatPromiseList).then(() => {
                            resolve()
                        })
                    })
                })

                // if (context.state.chatList) {
                //     newPayload = {offset: payload.offset + payload.limit, limit: 2000}
                //     isInit = false
                // }
                //
                // context.dispatch('retrieveChatList', newPayload).then(() => {
                //     if (isInit) {
                //
                //     }
                //     // if (process.env.NODE_ENV !== 'production') {
                //     //     resolve()
                //     //     return
                //     // }
                //     if (context.state.chatList.activityCount > context.state.chatList.activities.length) {
                //         context.dispatch('retrieveAllChatList', newPayload).then(() => {
                //             resolve()
                //         })
                //     } else {
                //         resolve()
                //     }
                // })
            })
        },
        retrieveChatList(context, payload) {
            return new Promise((resolve, reject) => {
                $axios
                    .get('activities', {
                        params: {
                            limit: payload.limit,
                            offset: payload.offset,
                            startDate: '1900-01-01T00:00:00Z'
                        }
                    })
                    .then(response => {
                        context.commit('retrieveChatList', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        retrieveChatDictionaryList(context) {
            return new Promise((resolve, reject) => {
                $axios
                    .get('activities/dictList')
                    .then(response => {
                        context.commit('retrieveChatDictionaryList', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        retrieveChat(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit('setChatForwardMode', false)
                if (!payload) {
                    context.commit('retrieveChat', null)
                    resolve()
                } else {
                    $axios
                        .get('activities/' + payload.chatId, {
                            params: {
                                commentLimit: payload.commentLimit,
                                isForward: payload.isForward
                            }
                        })
                        .then(response => {
                            context.dispatch('leaveGroup').then(() =>
                                context.dispatch('addToGroup', payload.chatId).then(() => {
                                    context.commit('retrieveChat', response.data)

                                    resolve(response.data)
                                })
                            )
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                }
            })
        },
        retrieveChatCommentHistory(context, payload) {
            return new Promise((resolve, reject) => {
                $axios
                    .get('activities/' + payload.chatId + '/Comments/' + payload.messageId, {
                        params: {
                            limit: payload.limit,
                            isForward: payload.isForward
                        }
                    })
                    .then(response => {
                        context.commit('retrieveChatCommentHistory', response.data)

                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        retrieveSearchChat(context, payload) {
            return new Promise((resolve, reject) => {
                $axios
                    .get('activities/' + payload.chatId + '/Comments/' + payload.messageId, {
                        params: {
                            limit: payload.limit,
                            isForward: payload.isForward
                        }
                    })
                    .then(response => {
                        let messages = response.data
                        context.commit('retrieveChatCommentList', {
                            isClean: payload.loadBefore,
                            messageList: messages
                        })
                        if (payload.loadBefore) {
                            context.dispatch('retrieveSearchChat', {
                                chatId: payload.chatId,
                                messageId: messages[messages.length - 1].id,
                                limit: 10,
                                loadBefore: false,
                                isForward: true
                            }).then(() => {
                                resolve()
                            })
                        } else {
                            resolve()
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        receiveChatComment(context, payload) {
            let currentChat = context.getters.currentChat
            if (currentChat.id === payload.chatId) {
                context.commit('retrieveChatNewComment', {comment: payload.comment, currentUser: context.getters.user})
                // this._vm.playSound('http://soundbible.com/mp3/Air Plane Ding-SoundBible.com-496729130.mp3')
            }
        },
        removeChatComment(context, payload){
            let currentChat = context.getters.currentChat
            if (currentChat.id === payload.chatId) {
                context.commit('removeChatComment', {comment: payload.comment})
            }
        },
        receiveUnreadCommentsNotification(context, data) {
            if (context.getters.currentChat && data.activityId === context.getters.currentChat.id) {
                return
            }
            let chatList = context.getters.chatList
            let chat = chatList.find(function (item) {
                return item.id === data.activityId
            })

            if (chat) {
                chat.unreadCommentsCount = data.unreadCommentsCount
                chat.lastCommentDate = this._vm.moment().utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z'
                // this._vm.playSound('http://soundbible.com/mp3/Air Plane Ding-SoundBible.com-496729130.mp3')
            }
        },
        cleanChatList(context) {
            return new Promise((resolve) => {
                context.commit('cleanChatList')

                return resolve()
            })
        },
        setChatForwardMode(context, payload) {
            context.commit('setChatForwardMode', payload)
        },
        addChatForwardMessage(context, payload){
            context.commit('addChatForwardMessage', payload)
        },
        removeChatForwardMessage(context, payload){
            context.commit('removeChatForwardMessage', payload)
        },
        clearChatForward(context) {
            context.commit('clearChatForward')
        },
        searchChatMessage(context, payload) {
            return new Promise((resolve, reject) => {
                $axios
                    .get(`activities/${context.getters.currentChat.id}/Comments/search`, {
                        params: {
                            text: payload
                        }
                    })
                    .then(response => {
                        context.commit('searchChatMessage', response.data)

                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        clearSearchChatMessage(context) {
            return new Promise((resolve) => {
                context.commit('clearSearchChatMessage')

                resolve()
            })
        },
        retrieveChatAttendees(context, payload) {
            return new Promise((resolve, reject) => {
                $axios
                    .get(`activities/${payload}/attendees`)
                    .then(response => {
                        context.commit('retrieveChatAttendees', response.data)

                        resolve()
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },

        setChatCreateServiceMode(context, payload) {
            context.commit('setChatCreateServiceMode', payload)
        },
        addChatCreateServiceMessage(context, payload){
            context.commit('addChatCreateServiceMessage', payload)
        },
        removeChatCreateServiceMessage(context, payload){
            context.commit('removeChatCreateServiceMessage', payload)
        },
        clearChatCreateService(context) {
            context.commit('clearChatCreateService')
        },
        getChatServicesInWorkList(context){
            return new Promise((resolve, reject) => {
                $axios
                    .get(`activities/${context.getters.currentChat.id}/servicesInWork`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        }
    },
    getters: {
        chatList(state) {
            return state.chatList ? state.chatList.activities.sort(function (a, b) {
                    return new Date(b.lastCommentDate) - new Date(a.lastCommentDate)
                })
                : []
        },
        chatDictionaryList(state) {
            return state.chatDictionaryList ? state.chatDictionaryList.sort((a, b) => a.name.localeCompare(b.name)) : []
        },
        currentChat(state) {
            return state.currentChat
        },
        currentChatMessages(state) {
            return state.currentChat ? state.currentChat.comments.sort(function (a, b) {
                return new Date(a.createdAt) - new Date(b.createdAt)
            }) : []
        },
        foundMessageList(state) {
            return state.foundMessageList
        },
        chatForwardMode(state) {
            return state.forward.mode
        },
        chatForwardMessageList(state) {
            return state.forward.messageList
        },
        chatCreateServiceMode(state) {
            return state.chatCreateService.mode
        },
        chatCreateServiceMessageList(state) {
            return state.chatCreateService.messageList
        },
    }
}